import { useState } from 'react';

export function Products() {
  const [expandedCard, setExpandedCard] = useState<number | null>(0);

  const products = [
    {
      id: 1,
      name: 'VPN Application',
      description: 'Secure and fast VPN service for iOS devices providing privacy protection and encrypted connections',
      features: [
        'Military-grade encryption',
        'Global server network',
        'No-logs policy',
        'One-tap connection'
      ],
      image: 'https://public.readdy.ai/ai/img_res/a6d9ebfc72fd918253f64de79f49bd5a.jpg'
    },
    {
      id: 2,
      name: 'Cleaner Application',
      description: 'Device optimization tool that helps users clean junk files, manage storage, and improve device performance',
      features: [
        'Smart storage analysis',
        'Duplicate file finder',
        'Photo compression',
        'Battery optimization'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20iOS%20cleaner%20application%20interface%20displaying%20storage%20analysis%20dashboard%20with%20colorful%20charts%20and%20graphs%20showing%20device%20optimization%2C%20clean%20minimalist%20design%20with%20teal%20and%20green%20accent%20colors%2C%20professional%20mobile%20app%20UI%20with%20storage%20categories%20and%20cleaning%20progress%20indicators%2C%20simple%20white%20background%20highlighting%20the%20interface%20elements&width=600&height=800&seq=cleaner-app-001&orientation=portrait'
    },
    {
      id: 3,
      name: 'Security Suite',
      description: 'Comprehensive security features protecting your iOS device from threats and vulnerabilities',
      features: [
        'Real-time threat detection',
        'Secure browsing',
        'Privacy scanner',
        'App permissions monitor'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20iOS%20security%20application%20interface%20showing%20protection%20dashboard%20with%20shield%20icons%20and%20security%20status%20indicators%2C%20clean%20minimalist%20design%20with%20blue%20and%20purple%20gradient%20colors%2C%20professional%20mobile%20app%20UI%20with%20threat%20detection%20and%20privacy%20monitoring%20features%2C%20simple%20white%20background%20highlighting%20the%20interface%20elements&width=600&height=800&seq=security-app-001&orientation=portrait'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Our Products 🛡️
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Innovative iOS solutions designed to enhance your mobile experience with cutting-edge security and performance optimization
          </p>
        </div>

        <div className="flex gap-6 items-stretch">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index ? 'flex-[1.2]' : 'flex-1'
              }`}
              onMouseEnter={() => setExpandedCard(index)}
              style={{ minHeight: '500px' }}
            >
              <img
                src={product.image}
                alt={product.name}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              <div className="relative h-full flex flex-col justify-end p-8">
                <h3 className="text-3xl font-bold text-white mb-3">
                  {product.name}
                </h3>
                <p className="text-base text-white/90 mb-4 leading-relaxed">
                  {product.description}
                </p>
                
                <div className={`transition-all duration-500 overflow-hidden ${
                  expandedCard === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <ul className="space-y-2">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-white/90 text-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-white/80"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
